/*global BMS*/
import {
    CREATE_DISABLED_GAMES,
    CREATE_GAMES,
    ENABLE_DISABLE_GAME,
    SELECT_GAME,
    SET_GAME_CONTROLLER_STATE, SET_PROMO_BALANCE_WEB, UPDATE_ON_LOAD
} from '../constants/actionTypes';
import defaultStoreValues from '../constants/defaultStoreValues';
import moment, {utc} from "moment";
import {setVideoMuted} from "../actions/systemActions";

const BET_SLIP_SIDE_VIEW_THRESHOLD_WIDTH = 950;
const CONSTS = require('../constants/communications');

export default (state, action) => {
    let newGames;
    let disabledGames;
    switch (action.type) {
        case CREATE_GAMES:
            newGames = action.gameList.map((gm) => {
                let ret = {
                    name: gm.name,
                    channel: gm.channel,
                    state: gm.state,
                    type: gm.type,
                    wsUrl: gm.URL.WS_URL,
                    videoUrl: gm.URL.VIDEO_URL,
                    assetsPath: gm.URL.BMS_ASSETS,
                    gameOrder: gm.displayOrder,
                    gameCategory: gm.category.name,
                    categoryOrder: gm.category.displayOrder,
                    ws: gm.ws
                };
                return ret;
            });

            return {
                ...state,
                games: newGames
            };
        case CREATE_DISABLED_GAMES:
            disabledGames = action.gameList.map((gm) => {
                let ret = {
                    name: gm.name,
                    channel: gm.channel,
                    state: gm.state,
                    type: gm.type,
                    assetsPath: gm.URL.BMS_ASSETS,
                    gameOrder: gm.displayOrder,
                    gameCategory: gm.category.name,
                };
                return ret;
            });

            return {
                ...state,
                disabledGames: disabledGames
            };
        case SELECT_GAME:
            let newSelectedGameIndex = action.gameIndex;
            newGames = state.games.slice();

            if (newSelectedGameIndex === state.selectedGameIndex) {
                return state;
            }
            if (process.env.NODE_ENV !== 'development' && !state.isVideoMuted) {
                BMS.Operator.updateGameSound(false);
            }
            newGames = newGames.map((gm, index) => {
                if (index === action.gameIndex) {
                    gm.ws = action.newWs;
                }

                return gm;
            });
            let isBetSlipModalOpen = document.getElementById("root").offsetWidth > BET_SLIP_SIDE_VIEW_THRESHOLD_WIDTH ? state.isBetSlipModalOpen : false;

            return {
                ...state,
                selectedGameIndex: newSelectedGameIndex,
                selectedEventIndex: defaultStoreValues.selectedEventIndex,
                selectedEventMultiBetList: defaultStoreValues.selectedEventMultiBetList.slice(),
                footballMarketsExpanded: state.footballMarketsExpanded,
                selectedRacingBetType: defaultStoreValues.selectedRacingBetType,
                selectedFootballBetType: defaultStoreValues.selectedFootballBetType,
                isSimpleBetsSelected: defaultStoreValues.isSimpleBetsSelected,
                isBoxBetsButtonToggled: defaultStoreValues.isBoxBetsButtonToggled,
                messageBar: defaultStoreValues.messageBar,
                isBetSlipModalOpen: isBetSlipModalOpen,
                games: newGames,
                isVideoMuted: true
            };
        case ENABLE_DISABLE_GAME:
            let newOpenBetsList = state.openBetsList;
            let newOpenBetsHistory = state.openBetsHistory;

            if (action.newGameState === 'false') {
                let game = state.games[action.gameIndex];
                newOpenBetsList = state.openBetsList.slice().filter(obl => obl.game.channel !== game.channel);
                if (newOpenBetsHistory) {
                    newOpenBetsHistory = state.openBetsHistory.slice().filter(obh => obh.game.channel !== game.channel);
                }
            }

            newGames = state.games.slice().map((gm, index) => {
                if (index === action.gameIndex) {
                    gm.state = action.newGameState;
                }

                return gm;
            });

            return {
                ...state,
                games: newGames,
                openBetsList: newOpenBetsList,
                openBetsHistory: newOpenBetsHistory
            };
        case SET_GAME_CONTROLLER_STATE:
            newGames = state.games.slice();
            let foundGame = action.isGroupedEvent === undefined || !action.isGroupedEvent ? newGames.find(g => g.channel === action.gameChannel) : undefined;
            if (foundGame !== undefined) {
                if (action.state === CONSTS.VC2_MESSAGE_TYPE.RESTD) {
                    //TODO: Remove this logic once controller timing issues are fixed. This is done for 2.0.2 release
                    if (foundGame.controllerState !== CONSTS.VC2_MESSAGE_TYPE.PRE) {
                        foundGame.controllerState = CONSTS.VC2_MESSAGE_TYPE.RES;
                    }
                    foundGame.isResulted = true;
                } else {
                    foundGame.controllerState = action.state;
                    foundGame.isResulted = false;
                }
                if (action.state === CONSTS.VC2_MESSAGE_TYPE.PRE) {
                    if (foundGame.isResultShowing) {
                        foundGame.controllerState = CONSTS.VC2_MESSAGE_TYPE.RES;
                    }
                }
            } else if (newGames.find(g => action.gameChannel.includes(g.channel)) != undefined) {
                foundGame = newGames.find(g => action.gameChannel.includes(g.channel));
                if (action.bulkUpdate) {
                    let controllerStates;
                    if (foundGame.controllerState !== undefined) {
                        controllerStates = foundGame.controllerState;
                    } else {
                        controllerStates = {};
                    }
                    for (let i = 1; i <= 8; i++) {
                        controllerStates[i] = action.state;
                    }
                    foundGame.controllerState = controllerStates;
                    foundGame.isResulted = false;

                    if (foundGame.controllerState !== undefined && foundGame.controllerState[1] !== CONSTS.VC2_MESSAGE_TYPE.RES) {
                        foundGame.isResultCountDownStart = false;
                    }
                } else {
                    let channelSplit = action.gameChannel.split('_');
                    let eventOrder = channelSplit[channelSplit.length - 1];

                    if (action.state === CONSTS.VC2_MESSAGE_TYPE.RESTD) {
                        //TODO: Remove this logic once controller timing issues are fixed. This is done for 2.0.2 release
                        if (foundGame.controllerState === undefined || foundGame.controllerState[eventOrder] === undefined ||
                            foundGame.controllerState[eventOrder] !== CONSTS.VC2_MESSAGE_TYPE.PRE) {
                            if (foundGame.controllerState === undefined)
                                foundGame.controllerState = {};
                            foundGame.controllerState[eventOrder] = CONSTS.VC2_MESSAGE_TYPE.RES;
                        }
                        foundGame.isResulted = true;
                    } else {
                        let controllerState;
                        if (foundGame.controllerState != undefined) {
                            controllerState = foundGame.controllerState;
                        } else {
                            controllerState = {};
                        }

                        if (action.state === CONSTS.VC2_MESSAGE_TYPE.NMB)
                            controllerState[1] = action.state;
                        else if (action.state === CONSTS.VC2_MESSAGE_TYPE.PRE && controllerState[1] === CONSTS.VC2_MESSAGE_TYPE.NMB)
                            controllerState[1] = CONSTS.VC2_MESSAGE_TYPE.NMB;
                        else
                            controllerState[eventOrder] = action.state;

                        foundGame.controllerState = controllerState;
                        foundGame.isResulted = false;
                    }

                    if (action.state === CONSTS.VC2_MESSAGE_TYPE.PRE) {
                        if (foundGame.isResultShowing) {
                            foundGame.controllerState[eventOrder] = CONSTS.VC2_MESSAGE_TYPE.RES;
                        }
                    }
                    if (foundGame.controllerState != undefined && foundGame.controllerState[eventOrder] !== CONSTS.VC2_MESSAGE_TYPE.RES) {
                        foundGame.isResultCountDownStart = false;
                    }
                }
            } else {
                console.log('Received game state update for non existing channel: got ' + action.gameChannel);
            }

            if (foundGame !== undefined && action.eventTimeDate !== undefined) {
                foundGame.liveEventTimeDate = action.eventTimeDate;
            }

            return {
                ...state,
                games: newGames
            };
        case  SET_PROMO_BALANCE_WEB:
            let promoBalanceInState = state.promoBalances;
            let webPromo = action.promoBalances;

             let newPromoBalance = [];
             if(promoBalanceInState.length > 0 ){
                 newPromoBalance = promoBalanceInState;
             }
            webPromo.map((webPromo) => {
                if (!newPromoBalance.includes(webPromo.PromoBetId)) {
                    const startDate = moment(webPromo.StartDate,'DD-MM-YYYY HH:mm').toDate();
                    const endDate = moment(webPromo.ExpireDate,'DD-MM-YYYY HH:mm').toDate();
                    let currentDate = new Date().toISOString();
                    let myDate = new Date(currentDate);
                    let offset = myDate.getTimezoneOffset() * 60 * 1000;
                    let currentDateInUTC = myDate.getTime() + offset;
                    if(currentDateInUTC >= startDate.getTime() && currentDateInUTC <= endDate.getTime()){
                        webPromo.ExpireDate=endDate.getTime();
                        newPromoBalance = newPromoBalance.concat(webPromo);
                    }

                }
            });
            return {
                ...state,
                promoBalances:newPromoBalance,
                promoBannerFromWeb:newPromoBalance
            }
        case UPDATE_ON_LOAD :{
            return {
                ...state,
                onLoad: !state.onLoad
                };
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/gamesReducer.js